<template>
  <div>
    <h1>Calendar</h1>

    <div v-if="isCalendarLoading" class="text-center pt-3">
      <b-spinner label="Loading..." />
    </div>

    <!--
    <FullCalendar v-else ref="calendar" :options="calendarOptions">
      <template v-slot:eventContent='arg'>
        <div class="unit-calendar-container" :style="{ color: arg.event.textColor, border: '1px solid ' + arg.event.borderColor, backgroundColor: arg.event.color }">
          <b v-if="companyPurpose === 'rent'">{{ getFormattedDate(arg.event) }} - </b>
          <i v-if="companyPurpose === 'rent'">{{ arg.event.title }}</i>
          <br v-if="companyPurpose === 'rent'" />
          <span>{{ arg.event.extendedProps.unit_name }}</span>
          <br/>
          <img
              :src="arg.event.extendedProps.unit_picture.includes('https') ? arg.event.extendedProps.unit_picture : '//' + arg.event.extendedProps.unit_picture"
              :class="'unit-picture-calendar'"
          />
        </div>
      </template>
    </FullCalendar>
    -->
      <FullCalendar :options='calendarOptions'>
      <template v-slot:eventContent='arg'>
<!--        <b>{{ arg.timeText }}</b>
        <i>{{ arg.event.title }}</i>-->
      </template>
    </FullCalendar>
    <div class="pb-3"></div>

    <b-modal
      id="details-modal"
      ok-only
      :title="companyPurpose === 'rent' ? 'Booking details' : 'Order details'"
      cancel-variant="outline-secondary"
    >
      <div
        v-if="isModalLoading"
        class="text-center"
      >
        <b-spinner label="Loading..." />
      </div>
      <template
        v-for="(value, key, index) in modal"
        v-else
      >
        <b-form-group
          v-if="value && (companyPurpose === 'rent' || key === 'unit' || key === 'date' || key === 'package' || key === 'name' || key === 'email' || key === 'phone')"
          :id="`input-group-${key}`"
          :key="index"
          :label="(companyPurpose !== 'rent' && key === 'unit') ? 'Product' : ((companyPurpose !== 'rent' && key === 'date') ? 'Delivery date' : key)"
          :label-for="`input-${key}`"
          class="capitalize"
        >
          <b-form-input
            :id="`input-${key}`"
            :value="value"
            readonly
          />
        </b-form-group>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BSpinner,
  BModal,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import axios from '@/libs/axios'
import { toastFailure } from '@/libs/toastification'
import '@fullcalendar/core/vdom'
import FullCalendar from '@fullcalendar/vue3'
import timeGridPlugin from '@fullcalendar/timegrid'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment-timezone'
import { companyTz, formatCompanyTime } from '@/libs/companyTime'

export default {
  components: {
    BSpinner,
    FullCalendar,
    BModal,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {

      calendarOptions: { // remove this (calendarOptions) after test
        //plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        timeZone: window.timezone_name || 'UTC',
        //weekends: false,
        events: [
          { title: 'Meeting', start: new Date() }
        ]
      },
      companyPurpose: window.companyPurpose,
      companyId: window.companyId,
      isCalendarLoading: true,
      events: [],
      isModalLoading: true,
      modal: {
        unit: null,
        package: null,
        date: null,
        time: null,
        name: null,
        email: null,
        phone: null,
        details: null,
      },
    }
  },
  computed: {
    /*calendarOptions() {

      return {
        plugins: [ timeGridPlugin, dayGridPlugin, interactionPlugin ],
        initialView: 'dayGridMonth',
        eventClick: this.handleEventClick,
        events: this.events
      }
    },*/
  },
  async mounted() {
    axios
      .get(
        'api/sales-calendar'
      )
      .then(response => {
        this.isCalendarLoading = false
        //this.events = response.data.data
      })
      .then(() => {
        //this.$refs.calendar.getApi().refetchEvents()
      })
      .catch(() => {
        toastFailure('@fullcalendar error')
      })
  },
  methods: {
    handleEventClick(info) {
      info.jsEvent.preventDefault()

      this.$root.$emit('bv::show::modal', 'details-modal')
      this.openDetailsModal(info.event.id)
    },
    openDetailsModal(saleId) {
      this.isModalLoading = true
      axios.get(`api/sale-details/${saleId}`)
        .then(response => {
          this.modal = { ...response.data.data }
          this.isModalLoading = false
        })
        .catch(() => {
          toastFailure('Something went wrong.')
        })
    },
    getFormattedDate (event) {
      const date = event.date || event.start

      if (date === undefined) {
        return ''
      }

      return formatCompanyTime(date) || moment.tz(date, companyTz()).format('HH:mm')
    }
  },
}
</script>

<style>
  @media (max-width: 400px) {
    .fc .fc-toolbar-title {
      font-size: 1.25em;
    }
  }

  @media (max-width: 340px) {
    .fc .fc-toolbar-title {
      font-size: 1em;
    }
  }
</style>
